
<template>
    <div class="center examplex">
      <vs-table striped>
        <template #thead>
          <vs-tr>
            <vs-th style="width: 40%;">
              Académico
            </vs-th>
            <vs-th style="width: 60%;">
              Finanzas
            </vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
            :key="i"
            v-for="(tr, i) in global"
            :data="tr"
            class="divisionLineas"
          >
            <vs-td>
                <p class="mb-0"><strong>{{tr.institucion}}</strong></p>
                <p><small>INSTITUCIÓN</small></p>
                <p class="mb-0"><strong>{{tr.ciclo_escolar}}</strong></p>
                <p><small>CICLO ESCOLAR</small></p>
                <p class="mb-0"><strong>{{tr.programa}}</strong></p>
                <p><small>PROGRAMA</small></p>
            </vs-td>
            <vs-td class="justify-content-between">
                <vs-row>
                    <vs-col w="6" class="p-2 ">
                        <div class="shadow p-3">
                            <p class="text-center"><strong>COLEGIATURAS</strong></p>
                            <div class="justify-content-between">
                                <div class="p-2 mr-4">
                                    <strong><small>CARGOS TOTALES</small></strong>
                                    <h5 class="mb-0">{{tr.cargos_totales_colegiaturas | currency}}</h5>
                                </div>
                                <div class="p-2 mr-4">
                                    <strong><small>CARGOS COBRADOS</small></strong>
                                    <h5 class="mb-0">{{tr.cargos_cobrados_colegiaturas | currency}}</h5>
                                </div>
                                <div class="p-2 mr-4">
                                    <strong><small>CARTERA VENCIDA</small></strong>
                                    <h5 class="mb-0">{{tr.cartera_vencida_colegiaturas | currency}}</h5>
                                </div>
                                <div class="p-2 mr-4">
                                    <strong><small>CARGOS EN TIEMPO</small></strong>
                                    <h5 class="mb-0">{{tr.cargos_en_tiempo_colegiaturas | currency}}</h5>
                                </div>
                                <div class="p-2 mr-4">
                                    <strong><small>PAGOS</small></strong>
                                    <h5 class="mb-0">{{tr.pagos_colegiaturas | currency}}</h5>
                                </div>
                                <div class="p-2 mr-4">
                                    <strong><small>BECAS</small></strong>
                                    <vs-tooltip warn>
                                        <md-chip class="mini-chip text-uppercase col-yellow"><strong>Becas aplicadas en estado de cuenta </strong></md-chip>
                                        <template #tooltip>
                                        <div class="content-tooltip">
                                            <p>
                                            Estas becas están sujetas a desaplicación en dado caso que se venzan, así mismo el monto reflejado esta parcialmente aplicado junto con un pago para saldar algún cargo por lo tanto ya no se podrán desaplicar
                                            </p>
                                        </div>
                                        </template>
                                    </vs-tooltip>
                                    <h5 class="mb-0">{{tr.becas_colegiaturas | currency}}</h5>
                                </div>
                                <div class="p-2">
                                    <strong><small>DESCUENTOS</small></strong>
                                    <h5 class="mb-0">{{tr.descuentos_colegiaturas | currency}}</h5>
                                </div>
                            </div>
                        </div>
                    </vs-col>
                    <vs-col w="6" class="p-2">
                        <div class="shadow p-3">
                            <p class="text-center"><strong>INSCRIPCIÓN</strong></p>
                            <div class="justify-content-between">
                                <div class="p-2 mr-4">
                                    <strong><small>CARGOS TOTALES</small></strong>
                                    <h5 class="mb-0">{{tr.cargos_totales_inscripciones | currency}}</h5>
                                </div>
                                <div class="p-2 mr-4">
                                    <strong><small>CARGOS COBRADOS</small></strong>
                                    <h5 class="mb-0">{{tr.cargos_cobrados_inscripciones | currency}}</h5>
                                </div>
                                <div class="p-2 mr-4">
                                    <strong><small>CARTERA VENCIDA</small></strong>
                                    <h5 class="mb-0">{{tr.cartera_vencida_inscripciones | currency}}</h5>
                                </div>
                                <div class="p-2 mr-4">
                                    <strong><small>CARGOS EN TIEMPO</small></strong>
                                    <h5 class="mb-0">{{tr.cargos_en_tiempo_inscripciones | currency}}</h5>
                                </div>
                                <div class="p-2 mr-4">
                                    <strong><small>PAGOS</small></strong>
                                    <h5 class="mb-0">{{tr.pagos_inscripciones | currency}}</h5>
                                </div>
                                <div class="p-2 mr-4">
                                    <strong><small>BECAS</small></strong>
                                    <vs-tooltip warn>
                                        <md-chip class="mini-chip text-uppercase col-yellow"><strong>Becas aplicadas en estado de cuenta </strong></md-chip>
                                        <template #tooltip>
                                        <div class="content-tooltip">
                                            <p>
                                            Estas becas están sujetas a desaplicación en dado caso que se venzan, así mismo el monto reflejado esta parcialmente aplicado junto con un pago para saldar algún cargo por lo tanto ya no se podrán desaplicar
                                            </p>
                                        </div>
                                        </template>
                                    </vs-tooltip>
                                    <h5 class="mb-0">{{tr.becas_inscripciones | currency}}</h5>
                                </div>
                                <div class="p-2">
                                    <strong><small>DESCUENTOS</small></strong>
                                    <h5 class="mb-0">{{tr.descuentos_inscripciones | currency}}</h5>
                                </div>
                            </div>
                        </div>
                    </vs-col>
                </vs-row>
            </vs-td>
          </vs-tr>
        </template>
        <template #notFound>
            Sin información
        </template>
      </vs-table>
    </div>
</template>
<script>
export default {
    props: [
        'global'
    ],
    data:() => ({
    })
}
</script>

<style lang="scss" scoped >
@mixin text-colors ($theme, $text-color, $background) {
    &.col-#{$theme}{
        color: $text-color !important;
        background-color: $background !important;
    }
}

.md-chip{
    &.mini-chip{
        height: 21px;
        padding: 0px 5px;
        font-size: 12px;
        line-height: 23px;
    }
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb); 
    @include text-colors ('blue', #2d8bf6, #deecfc ); 
    @include text-colors ('yellow', #febf3d, rgb(255, 248, 236) );
    @include text-colors ('purple', purple, rgb(232, 218, 239));
    @include text-colors ('pink', #F08080, rgb(255, 236, 236));
}

label {
    margin-bottom: 0.1rem  !important;
}

.label-color {   
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb);  
    @include text-colors ('blue', #92bff1, #c7e1ff ); 
    @include text-colors ('yellow', #febf3d, rgb(255, 248, 236) );
    @include text-colors ('purple', purple, rgb(232, 218, 239));
    @include text-colors ('pink', #F08080, rgb(255, 236, 236));
}

.col-purple{
    color: purple;
    background: rgb(234, 228, 236);
}
.fontBiger{
    font-size: 22px;
}
.fontBig{
    font-size: 16px;
}
.fontMedium{
    font-size: 15px;
}

.fontSmall{
    font-size: 12px;
}

.breakInfo{
    word-break: break-all;
}

</style>
<style scoped>
  .divisionLineas:not(:last-child){
      border-bottom: 1px solid #E5E7E9; 
  }
  .divisionLineas{
      padding: 2% 0;
  }
</style>

        